import { useEffect, useState } from 'react';
import { ShieldAlert, X } from 'lucide-react';

export function ImpersonationBanner() {
  const [impersonationData, setImpersonationData] = useState<{ name: string; email: string } | null>(null);

  useEffect(() => {
    const data = sessionStorage.getItem('impersonation_user');
    if (data) {
      try {
        setImpersonationData(JSON.parse(data));
      } catch {
        // invalid data
      }
    }
  }, []);

  const handleExit = () => {
    sessionStorage.removeItem('impersonation_token');
    sessionStorage.removeItem('impersonation_user');
    sessionStorage.removeItem('impersonation_active');
    window.close();
    // Fallback: if window.close doesn't work (not opened by script), redirect to admin
    setTimeout(() => {
      window.location.href = '/admin';
    }, 300);
  };

  if (!impersonationData) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-red-600 text-white py-2 px-4 shadow-lg">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ShieldAlert className="h-4 w-4 shrink-0" />
          <span className="text-sm font-medium">
            Admin Impersonation Active — Viewing as{' '}
            <strong>{impersonationData.name}</strong> ({impersonationData.email})
          </span>
        </div>
        <button
          onClick={handleExit}
          className="flex items-center gap-1 px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-sm font-medium transition-colors"
        >
          <X className="h-3 w-3" />
          Exit Impersonation
        </button>
      </div>
    </div>
  );
}
